// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__iframe___1tln7{background-color:#fff;border:0;height:100%;left:13%;overflow:auto;position:relative;width:74%}", ""]);
// Exports
exports.locals = {
	"iframe": "index__iframe___1tln7"
};
module.exports = exports;
